var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 704.167H216.667V1083.33C216.667 1143.08 265.254 1191.67 325 1191.67H975C1034.75 1191.67 1083.33 1143.08 1083.33 1083.33V704.167H1137.5C1148.21 704.164 1158.68 700.986 1167.59 695.034C1176.49 689.082 1183.43 680.623 1187.53 670.727C1191.63 660.831 1192.7 649.941 1190.61 639.436C1188.53 628.93 1183.37 619.279 1175.8 611.704L688.296 124.204C683.27 119.169 677.301 115.175 670.729 112.45C664.158 109.725 657.114 108.322 650 108.322C642.886 108.322 635.842 109.725 629.271 112.45C622.7 115.175 616.73 119.169 611.704 124.204L124.204 611.704C116.631 619.279 111.474 628.93 109.385 639.436C107.296 649.941 108.369 660.831 112.468 670.727C116.566 680.623 123.507 689.082 132.413 695.034C141.318 700.986 151.789 704.164 162.5 704.167ZM541.667 1083.33V812.5H758.333V1083.33H541.667ZM650 239.092L975 564.091V812.5L975.054 1083.33H866.667V812.5C866.667 752.754 818.079 704.167 758.333 704.167H541.667C481.921 704.167 433.333 752.754 433.333 812.5V1083.33H325V564.091L650 239.092Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxHome);
export default __webpack_public_path__ + "static/media/bx_home.9f383cd17bc66b0400a3655d54c9340b.svg";
export { ForwardRef as ReactComponent };